import { UserAgent } from "silver";

export enum AppIntentType {
	iOS = 1,
	Android,
	ChromeOS
}

export function getMobileIntentType(userAgent: UserAgent) : AppIntentType|null {
	if (userAgent.platform == "iPad") {
		return AppIntentType.iOS;
	}

	const isAndroid = (userAgent.platform === "Android" && userAgent.browser !== "Silk");
	const isSilk = (userAgent.platform === "Kindle Fire" && userAgent.browser === "Silk");
	if (isAndroid || isSilk) {
		return AppIntentType.Android;
	}

	const chrome: any = (window as any).chrome;
	if (chrome && chrome.runtime && chrome.runtime.sendMessage) {
		return AppIntentType.ChromeOS;
	}

	// iPadOS Now Identifies as macOS - https://stackoverflow.com/questions/56578799/tell-ipados-from-macos-on-the-web
	if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
		return AppIntentType.iOS;
	}

	return null;
}
